import { useDispatch, useSelector } from "react-redux";
import styles from "./addProductWizard.module.scss";
import React, { useState } from "react";
import { selectProductMethod, setAddProductMethod } from "./AddProductWizardSlice"

const AddProductMethod = () => {

  const dispatch = useDispatch();
  const selectedValue = useSelector(selectProductMethod);

  const handleRadioChange = (value) => {
    dispatch(setAddProductMethod(value))

    setTimeout(() => {
        console.log(selectedValue)
    }, 1000)
  };

  return (
    <div className={styles.addProductMethodContainer}>
      <div className={styles.description}>How do you want to proceed?</div> <br />
      <div className={styles.radioGroupContainer}>
        <div className={styles.radioContainer}>
          <input
            type="radio"
            id="copyFromExisting"
            value="copyFromExisting"
            checked={ selectedValue === "copyFromExisting" }
            onChange={() => handleRadioChange("copyFromExisting")}
          />
          <label htmlFor="copyFromExisting" className={styles.radioLabel}>
            Copy from Existing
          </label>
        </div>

        <div className={styles.radioContainer}>
          <input
            type="radio"
            id="createNew"
            value="createNew"
            checked={ selectedValue === "createNew" }
            onChange={() => handleRadioChange("createNew")}
          />
          <label htmlFor="createNew" className={styles.radioLabel}>
            Create New
          </label>
        </div>
      </div>
    </div>
  )
}

export default AddProductMethod;